import { getExactPostDate } from "components/analytics/utils";
import moment from "moment";

export interface PostStat {
  date: string;
  previewText: {
    text: string
    tweet: any
    textEscaped: string
    labels: string
  }
  impression: number
  engagement: number
  likes: number
  replies: number
  shares: number
  engagementPercent: number
  ai: any
  name: string
  username: string
  media: string
  url: string
}

export interface PostPerformance {
  maxImpression: number
  maxEngagement: number
  maxEngagementPercent: number
  maxLikes: number
  maxReplies: number
  maxShares: number
  stats: PostStat[]
}

export const mapPostsPerformance = (stats, account): PostPerformance => {
  let maxImpression = 0;
  let maxEngagement = 0;
  let maxEngagementPercent = 0;
  let maxLikes = 0;
  let maxReplies = 0;
  let maxShares = 0;

  const mappedStats = stats.map((stat): PostStat => {
    //console.log('tweet perf stat', stat);
    const engagementPercent = (!stat.numViews)
      ? 0
      : (stat.totalEngagement * 100) / stat.numViews;

    if (!stat.numViews) stat.numViews = 0; //fix stat.numViews coming up as NaN or undefined in the table.

    let createdAt = moment(getExactPostDate(stat.idShort))?.format("MMM. Do ’YY @ HH:mm");
    if (stat.numViews > maxImpression) maxImpression = stat.numViews;
    if (stat.totalEngagement > maxEngagement) maxEngagement = stat.totalEngagement;
    if (engagementPercent > maxEngagementPercent) maxEngagementPercent = engagementPercent;
    if (stat.numLikes > maxLikes) maxLikes = stat.numLikes;
    if (stat.numComments > maxReplies) maxReplies = stat.numComments;
    if (stat.totalShares > maxShares) maxShares = stat.totalShares;

    let media = "";

    let content = stat?.zFull?.content;

    if (content?.["com.linkedin.voyager.feed.render.ImageComponent"]) {
      let img = content?.["com.linkedin.voyager.feed.render.ImageComponent"]?.images[0]?.attributes?.[0];
      media = img?.vectorImage?.rootUrl + img?.vectorImage.artifacts?.[0]?.fileIdentifyingUrlPathSegment;
    }
    else if (content?.["com.linkedin.voyager.feed.render.LinkedInVideoComponent"]) {
      let videoDetails = content?.["com.linkedin.voyager.feed.render.LinkedInVideoComponent"]?.videoPlayMetadata;
      media = videoDetails?.progressiveStreams?.[1]?.streamingLocations[0]?.url || videoDetails?.progressiveStreams?.[0]?.streamingLocations[0]?.url;
    }
    else if (content?.["com.linkedin.voyager.feed.render.DocumentComponent"]) {
      let docDetails = content?.["com.linkedin.voyager.feed.render.DocumentComponent"]?.videoPlayMetadata;
      media = docDetails?.carousel_document_link || docDetails?.document?.transcribedDocumentUrl;
    }

    const currentLabels = account?.tweetLabels ?? [];
    let exportLabels = currentLabels.map((label) => {
      return (stat?.labels?.includes(label?.id)) ? label?.title : "";
    });

    exportLabels = exportLabels?.filter(n => n)?.join(", ");

    return {
      date: createdAt,
      previewText: {
        text: stat.text,
        tweet: stat,
        textEscaped: stat.text.replace(/"/g, '""'),
        labels: exportLabels
      },
      impression: stat.numViews,
      engagement: stat.totalEngagement,
      likes: stat.numLikes,
      replies: stat.numComments,
      shares: stat.totalShares,
      engagementPercent: engagementPercent,
      ai: stat,
      name: stat?.user?.name ?? stat?.user?.firstName + " " + stat?.user?.lastName,
      username: stat?.user?.username,
      media,
      url: "https://www.linkedin.com/feed/update/" + stat.id,
    };
  });

  return {
    maxImpression,
    maxEngagement,
    maxEngagementPercent,
    maxLikes,
    maxReplies,
    maxShares,
    stats: mappedStats
  }
}